"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAutoViewPayloads = void 0;
var scf_register_view_helper_1 = require("@microchip/scf-register-view-helper");
var Utils_1 = require("../../Utils");
var AutoModuleHelper = __importStar(require("../AutoModuleHelpers"));
var getConfigData_1 = require("../getConfigData");
var registerFilter = __importStar(require("../RegisterFilterMode"));
var autoModuleViewHelpers_1 = require("./autoModuleViewHelpers");
var formData_1 = require("./formData");
var scfUiSchema_1 = require("./scfUiSchema");
var schema_1 = require("./schema");
var uiSchema_1 = require("./uiSchema");
var createAutoViewPayloads = function (model) {
    var config = (0, getConfigData_1.getConfigData)(model);
    var payloads = {
        main: {},
    };
    if (config === null || config === void 0 ? void 0 : config.tabs) {
        Object.keys(config.tabs).forEach(function (tab) {
            payloads[tab] = getPayloadForTab(tab);
        });
    }
    return payloads;
    function getPayloadForTab(tab) {
        if (tab === "register") {
            return createSimpleFormPayloadRegister();
        }
        var viewModel = {
            components: model.getAutoModuleAppModel().getAllComponents(),
            getComponent: model.getComponent,
            imports: model.getImports(),
            derivedFunctions: model.getDerivedFunctions(),
            getAssignedImport: model.getAssignedImport,
            getTableHelpers: model.getTableHelpers,
        };
        var schemaViewModel = {
            viewModel: viewModel,
            getDerivedFunction: {
                overrideTitle: model.getDerivedFunction("overrideTitle"),
                isVisible: function (componentName) { var _a, _b; return (_b = (_a = model.getDerivedFunctions()).isVisible) === null || _b === void 0 ? void 0 : _b.call(_a, componentName); },
                getFunction: model.getDerivedFunction,
            },
            overrideTableOptions: model.getDerivedFunctions()["overrideTableOptions"],
            overrideDefaultValues: model.getDerivedFunctions()["overrideTableDefaultValues"],
            model: model,
        };
        var uiSchemaViewModel = {
            viewModel: viewModel,
            getDerivedFunction: {
                isEnabled: function (componentName) { var _a, _b; return (_b = (_a = model.getDerivedFunctions()).isEnabled) === null || _b === void 0 ? void 0 : _b.call(_a, componentName); },
                getUiBehavior: function (componentName) { var _a, _b; return (_b = (_a = model.getDerivedFunctions()).getUiBehavior) === null || _b === void 0 ? void 0 : _b.call(_a, componentName); },
                isVisible: function (componentName) { var _a, _b; return (_b = (_a = model.getDerivedFunctions()).isVisible) === null || _b === void 0 ? void 0 : _b.call(_a, componentName); },
            },
            getProcessedArgValue: model.getExportInterfaces().getProcessedArgValue,
            isControlledByInterface: model.isControlledByInterface,
        };
        return {
            schema: (0, schema_1.createSchema)(tab, config, schemaViewModel),
            uiSchema: (0, uiSchema_1.createUiSchema)(tab, config, uiSchemaViewModel),
            formData: (0, formData_1.createFormData)(tab, config, model),
            scfUiSchema: (0, scfUiSchema_1.createScfUiSchema)(tab, config, model),
            name: config === null || config === void 0 ? void 0 : config.tabs[tab],
            table: (0, autoModuleViewHelpers_1.shouldPopulateView)(model.getDerivedFunctions(), model.getImports(), model.getAssignedImport, config)
                ? model === null || model === void 0 ? void 0 : model.getDerivedFunction("getTableData")
                : undefined,
            expandGroupsByDefault: (config === null || config === void 0 ? void 0 : config.UIGroupCollapse)
                ? config.UIGroupCollapse
                : true,
        };
    }
    function createSimpleFormPayloadRegister() {
        if (!(config === null || config === void 0 ? void 0 : config.peripherals)) {
            return {};
        }
        var registerViewPayloads = [];
        config.peripherals.forEach(function (peripheral) {
            var _a, _b, _c, _d, _e, _f;
            if (AutoModuleHelper.hasConfigBits(peripheral.interfaceId.name)) {
                return;
            }
            var hardwarePeripheral = (_a = model
                .getHardware(peripheral.interfaceId.name)) === null || _a === void 0 ? void 0 : _a.getPeripheral();
            if (!(hardwarePeripheral === null || hardwarePeripheral === void 0 ? void 0 : hardwarePeripheral.registers)) {
                return;
            }
            var registerValues = model.getRegisterValues(peripheral.interfaceId.name);
            var interrupts = model.getInterrupts();
            hardwarePeripheral = registerFilter.processRegisterModes(peripheral, hardwarePeripheral, model);
            //TODO: implement for all peripherals
            var registerView = scf_register_view_helper_1.CreateRegisterView.for(hardwarePeripheral);
            if (registerValues) {
                (_b = (0, Utils_1.getKeys)(registerValues !== null && registerValues !== void 0 ? registerValues : {})) === null || _b === void 0 ? void 0 : _b.forEach(function (registerName) {
                    var _a;
                    var foundRegister = (_a = hardwarePeripheral === null || hardwarePeripheral === void 0 ? void 0 : hardwarePeripheral.registers) === null || _a === void 0 ? void 0 : _a[registerName];
                    if (foundRegister) {
                        registerView.withRegisterValue(foundRegister, registerValues[registerName].value);
                    }
                });
            }
            for (var interruptsKey in interrupts !== null && interrupts !== void 0 ? interrupts : {}) {
                var interrupt = interrupts === null || interrupts === void 0 ? void 0 : interrupts[interruptsKey];
                if (interrupt) {
                    var interruptComponent = model.getComponent(interruptsKey.toLowerCase());
                    var interruptCompVal = typeof (interruptComponent === null || interruptComponent === void 0 ? void 0 : interruptComponent.value) === "boolean"
                        ? (interruptComponent === null || interruptComponent === void 0 ? void 0 : interruptComponent.value)
                            ? "enabled"
                            : "disabled"
                        : interruptComponent === null || interruptComponent === void 0 ? void 0 : interruptComponent.value;
                    registerView
                        .withInterruptValue(interrupt, (_c = interruptCompVal !== null && interruptCompVal !== void 0 ? interruptCompVal : interrupt.defaultValue) !== null && _c !== void 0 ? _c : "disabled")
                        .withInterruptOptions(interrupt, (_f = (_e = (_d = interruptComponent === null || interruptComponent === void 0 ? void 0 : interruptComponent.component) === null || _d === void 0 ? void 0 : _d["defaultValue"]) === null || _e === void 0 ? void 0 : _e.options) !== null && _f !== void 0 ? _f : [
                        "enabled",
                        "disabled",
                    ]);
                }
            }
            registerViewPayloads.push(registerView.create());
        });
        return registerViewPayloads[0];
    }
};
exports.createAutoViewPayloads = createAutoViewPayloads;
//# sourceMappingURL=autoModuleView.js.map